import React from 'react'
import { Navigate } from 'react-router-dom'
import loadable from '@loadable/component'

import { SiteUrls } from '@/routes/siteUrls'

// Layout
const LoginLayout = loadable(() => import('@/layouts/LoginLayout'))
const DefaultLayout = loadable(() => import('@/layouts/DefaultLayout'))
// login
const LoginMain = loadable(() => import('@/pages/login/Login'))
// User
const UserList = loadable(() => import('@/pages/user/List'))
const UserCreate = loadable(() => import('@/pages/user/UserCreate'))
const UserDetail = loadable(() => import('@/pages/user/UserDetail'))
// Marketing
const BulkMail = loadable(() => import('@/pages/marketing/BulkMail'))
const InquiryList = loadable(() => import('@/pages/marketing/InquiryList'))
const InquiryDetail = loadable(() => import('@/pages/marketing/InquiryDetail'))
// Task
const TaskList = loadable(() => import('@/pages/task/List'))
// AI Node
const AINodeList = loadable(() => import('@/pages/aiNode/List'))
const Hyperparameters = loadable(() => import('@/pages/aiNode/Hyperparameters'))

// USAGE
const Usage = loadable(() => import('@/pages/metrics/Usage'))

// manual
const Manual = loadable(() => import('@/pages/manual/ManualPage'))

const routes = () => [
  {
    path: SiteUrls.Landing,
    element: <Navigate to={SiteUrls.Login._} replace />,
  },
  {
    path: SiteUrls.Login._,
    element: <LoginLayout />,
    children: [
      {
        path: '',
        element: <LoginMain />,
        children: [
          // {
          //   path: SiteUrls.login.SignUp,
          //   element: <SignUp />,
          // },
          // {
          //   path: SiteUrls.login.RecoverPassword,
          //   element: <RecoverPassword />,
          // },
        ],
      },
    ],
  },
  {
    path: SiteUrls.User._,
    element: <DefaultLayout />,
    children: [
      {
        path: SiteUrls.User.List,
        element: <UserList />,
      },
      {
        path: SiteUrls.User.Detail(':id'),
        element: <UserDetail />,
      },
      {
        path: SiteUrls.User.Signup,
        element: <UserCreate />,
      },
    ],
  },
  {
    path: SiteUrls.Marketing._,
    element: <DefaultLayout />,
    children: [
      {
        path: SiteUrls.Marketing.BulkMail,
        element: <BulkMail />,
      },
      {
        path: SiteUrls.Marketing.InquiryList,
        element: <InquiryList />,
      },
      {
        path: SiteUrls.Marketing.InquiryDetail(':id'),
        element: <InquiryDetail />,
      },
    ],
  },
  {
    path: SiteUrls.Task._,
    element: <DefaultLayout />,
    children: [
      {
        path: SiteUrls.Task.List,
        element: <TaskList />,
      },
    ],
  },
  {
    path: SiteUrls.AINode._,
    element: <DefaultLayout />,
    children: [
      {
        path: SiteUrls.AINode.List,
        element: <AINodeList />,
      },
      {
        path: SiteUrls.AINode.Hyperparameters,
        element: <Hyperparameters />,
      },
    ],
  },
  {
    path: SiteUrls.Metrics._,
    element: <DefaultLayout />,
    children: [
      {
        path: SiteUrls.Metrics.Usage,
        element: <Usage />,
      },
    ],
  },
  {
    path: SiteUrls.Manual._,
    element: <DefaultLayout />,
    children: [
      {
        path: SiteUrls.Manual.Write,
        element: <Manual />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to={SiteUrls.Login._} replace />,
  },
]

export default routes
